import {
  useEffect,
  useState,
} from "react";
import {
  useDispatch,
  useSelector,
} from "react-redux";
import {
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import {
  onAuthStateChanged,
  signOut,
} from "firebase/auth";
import {
  doc,
  getDoc,
} from "firebase/firestore";
import PendingUsers from "./components/admin/PendingUsers";
import {
  Center,
  Spinner,
} from "@chakra-ui/react";

import {
  auth,
  db,
} from "./firebase/config";
import {
  LOGIN_SUCCESS,
  LOGOUT,
} from "./redux/auth/authTypes";

import Navbar from "./components/Navbar";
import LoginPage from "./pages/LoginPage";
import AccountPage from "./pages/AccountPage";
import RegisterForm from "./components/RegisterForm";
import PrivateRoute from "./components/PrivateRoute";
import PublicRoute from "./components/PublicRoute";
import Dashboard from "./pages/Dashboard";
import AddNewProject from "./components/projects/AddNewProject";
import Project from "./components/projects/Project";
import Projects from "./components/projects/Projects";

function App() {
  const dispatch = useDispatch();
  const location = useLocation();

  const { user } = useSelector(
    (state) => state.auth
  );

  const [authInitialized, setAuthInitialized] =
    useState(false);

  useEffect(() => {
    let isActive = true;

    const unsubscribe =
      onAuthStateChanged(
        auth,
        async (firebaseUser) => {
          if (!isActive) return;

          if (!firebaseUser) {
            dispatch({
              type: LOGOUT,
            });

            setAuthInitialized(true);
            return;
          }
          /*
 * Registration temporarily signs the new user in only
 * long enough to send Firebase's verification email.
 * Do not treat that as an authenticated app session.
 */
const authenticationWorkflowInProgress =
  sessionStorage.getItem(
    "registrationVerificationInProgress"
  ) === "true" ||
  sessionStorage.getItem(
    "loginValidationInProgress"
  ) === "true";

if (authenticationWorkflowInProgress) {
  dispatch({
    type: LOGOUT,
  });

  setAuthInitialized(true);
  return;
}

          try {
            const profileSnapshot =
              await getDoc(
                doc(
                  db,
                  "users",
                  firebaseUser.uid
                )
              );

            if (
              !profileSnapshot.exists() ||
              profileSnapshot.data().active ===
                false
            ) {
              await signOut(auth);

              if (isActive) {
                dispatch({
                  type: LOGOUT,
                });
              }

              return;
            }

            const profile =
              profileSnapshot.data();
              /*
 * Existing approved accounts do not carry the
 * emailVerificationRequired flag. New registrations do.
 */
if (
  profile.emailVerificationRequired ===
    true &&
  firebaseUser.emailVerified !== true
) {
  await signOut(auth);

  if (isActive) {
    dispatch({
      type: LOGOUT,
    });
  }

  return;
}

            if (isActive) {
              dispatch({
                type: LOGIN_SUCCESS,
                payload: {
                  uid: firebaseUser.uid,
                  email: firebaseUser.email,
                  displayName:
                    firebaseUser.displayName ||
                    profile.displayName ||
                    "",
                  ...profile,
                },
              });
            }
          } catch (error) {
            console.error(
              "Session validation failed:",
              {
                code:
                  error.code || "unknown",
              }
            );

            try {
              await signOut(auth);
            } catch (signOutError) {
              console.error(
                "Invalid session sign-out failed:",
                {
                  code:
                    signOutError.code ||
                    "unknown",
                }
              );
            }

            if (isActive) {
              dispatch({
                type: LOGOUT,
              });
            }
          } finally {
            if (isActive) {
              setAuthInitialized(true);
            }
          }
        }
      );

    return () => {
      isActive = false;
      unsubscribe();
    };
  }, [dispatch]);

  if (!authInitialized) {
    return (
      <Center minH="100vh">
        <Spinner
          size="xl"
          thickness="4px"
          speed="0.65s"
          color="teal.500"
        />
      </Center>
    );
  }

  const publicPaths = [
    "/login",
    "/register",
  ];

  const shouldHideNavbar =
    publicPaths.includes(
      location.pathname
    );

  return (
    <>
      {user &&
        !shouldHideNavbar && (
          <Navbar />
        )}

      <Routes>
        <Route
          path="/login"
          element={
            <PublicRoute>
              <LoginPage />
            </PublicRoute>
          }
        />

        <Route
          path="/register"
          element={
            <PublicRoute>
              <RegisterForm />
            </PublicRoute>
          }
        />

        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />

        <Route
          path="/account"
          element={
            <PrivateRoute>
              <AccountPage />
            </PrivateRoute>
          }
        />
<Route
  path="/admin/users"
  element={
    <PrivateRoute>
      <PendingUsers />
    </PrivateRoute>
  }
/>
        <Route
          path="/projects"
          element={
            <PrivateRoute>
              <Projects />
            </PrivateRoute>
          }
        />

        <Route
          path="/projects/new"
          element={
            <PrivateRoute>
              <AddNewProject />
            </PrivateRoute>
          }
        />

        <Route
          path="/projects/:id"
          element={
            <PrivateRoute>
              <Project />
            </PrivateRoute>
          }
        />

        <Route
          path="/"
          element={
            <Navigate
              to="/dashboard"
              replace
            />
          }
        />

        <Route
          path="*"
          element={
            <Navigate
              to="/dashboard"
              replace
            />
          }
        />
      </Routes>
    </>
  );
}

export default App;